"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
var _Sun = _interopRequireDefault(require("../../Svg/TYWSymbols/Sun"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _analytics = require("../../../helpers/analytics");
var Chat = function Chat(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'tyw' : _ref$brand,
    emailAddress = _ref.emailAddress,
    showWhatsapp = _ref.showWhatsapp;
  var showDecoration = brand === 'tyw';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component position-relative"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-left text-md"
  }, "Chat with us"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-bottom-md"
  }, "Click the button to below to start a chat with a member from our team, or request a callback."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-width-xxxxs margin-auto margin-top-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Start Live Chat",
    className: "".concat(_analytics.GA4_TRIGGERS.EMAIL_TEAM_CLASS, " margin-bottom-md"),
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    icon: "headphones",
    external: true,
    link: "mailto:".concat(emailAddress),
    fullWidth: true,
    id: "d8-js-open-chat"
  }), showWhatsapp && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Whatsapp chat",
    className: "".concat(_analytics.GA4_TRIGGERS.WHATSAPP_CLASS, " margin-bottom-md"),
    buttonType: _constants.BUTTON_TYPES.WHATSAPP,
    fullWidth: true,
    external: true,
    link: "https://wa.me/447741887926",
    icon: "whatsapp"
  })), showDecoration && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute width-100% height-100%",
    style: {
      top: 0,
      left: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute",
    style: {
      display: 'inline-block',
      bottom: 0,
      right: 0,
      zIndex: 0,
      opacity: 0.2
    }
  }, /*#__PURE__*/_react["default"].createElement(_Sun["default"], {
    className: "icon--xxl",
    fill: "#DEE253"
  }))));
};
var _default = exports["default"] = Chat;